import rasking from "./previews/landing.png"
import tiptap from "./previews/previewTipTap.png"

const data = [
    {
        "preview": tiptap,
        "name": "Tip Tap Delivery",
        "summary": "Food delivery app",
        "logo": "https://firebasestorage.googleapis.com/v0/b/pands-tech.appspot.com/o/icon.png?alt=media&token=aba16bae-88ba-4b38-a02e-3c552b259b9e",
        "android": "https://play.google.com/store/apps/details?id=com.kulturersa.tiptap&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
        "ios": "https://apps.apple.com/us/app/tip-tap-sa/id6447940931"
    },
    {
        "preview": rasking,
        "name": "Rasking Fast Food",
        "summary": "Food Ordering Website",
        "logo": "https://firebasestorage.googleapis.com/v0/b/pands-tech.appspot.com/o/IMG-20230509-WA0000.jpg?alt=media&token=c87171c2-5586-48e2-999a-cf07c1c99f71",
        "website": "https://order-rasking.web.app"
    }
]

export default data